import { map } from 'lodash';
import classnames from 'classnames';
import React, { useMemo } from 'react';
import EditSessionRender from '../../containers/EditSessionProvider/EditSessionRender';
import useLayoutDirection from '../../utils/Translations/useLayoutDirection';
import useHelpNoteTitle from '../../utils/Translations/useHelpNoteTitle';
import useT from '../../utils/Translations/useT';
import Dropdown from '../Dropdown';
import styles from './PanelButton.scss';
import PanelButtonDivider from './PanelButtonDivider';
import buttonStyles from './AddButtonMultiple.scss';
import Spinner from '../../utils/Spinner';
const AddButtonMultiple = ({ title = '', actionList = [], onAction, isSingle = false, isDisabled = false, isLoading = false, iconClass = 'plus3', classStyle, plainTitle = null, menuContainerClassName = null, isRenderedInPortal = false, dataCy, }) => {
    const t = useT();
    const { isLayoutRTL } = useLayoutDirection();
    const _title = useMemo(() => plainTitle || t('Add #{name}', { name: `[${title}]` }), [t, title, plainTitle]);
    const resolvedTooltipTitle = useHelpNoteTitle(_title);
    const _actions = useMemo(() => map(actionList, ({ name, id, dataCy: actionDataCy }) => ({
        dataCy: actionDataCy || (dataCy ? `${dataCy}-item-${id}` : undefined),
        label: name,
        onClick: () => !isDisabled && onAction && onAction(id),
    })), [dataCy, onAction, actionList, isDisabled]);
    const _icon = useMemo(() => [
        {
            name: iconClass,
            className: classnames(styles.iconColor, {
                [buttonStyles.disabled]: isDisabled,
            }),
        },
        {
            name: 'arrow-down2',
            className: classnames(styles.iconColorSmall, isLayoutRTL ? 'mr-5' : 'ml-5', {
                [buttonStyles.disabled]: isDisabled,
            }),
        },
    ], [iconClass, isDisabled, isLayoutRTL]);
    if (isLoading) {
        return (<EditSessionRender>
        <Spinner />
      </EditSessionRender>);
    }
    return (<EditSessionRender>
      <>
        <div className={classnames(styles.iconPosition, classStyle)} data-cy={dataCy} title={resolvedTooltipTitle}>
          <Dropdown noPull actions={_actions} buttonClassName={styles.actionButton} dataCy={dataCy} icon={_icon} isDisabled={isDisabled} isRenderedInPortal={isRenderedInPortal} menuContainerClassName={menuContainerClassName} title={_title}/>
        </div>
        {isSingle ? null : <PanelButtonDivider />}
      </>
    </EditSessionRender>);
};
export default AddButtonMultiple;
